import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const ErrorIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon sx={{ ...sx }} width="64" height="64" viewBox="0 0 64 64" fill="none">
      <g clipPath="url(#clip0_5793_11990)">
        <path
          d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64Z"
          fill="#FF5F57"
        />
        <path
          d="M20.5 43.5L39.2915 63C53.1985 59.5912 63.5 47.9446 63.5 34.0254C63.5 33.7413 63.5 33.4573 63.5 33.1732L44 20.5L20.5 43.5Z"
          fill="#EF534A"
        />
        <path
          d="M38.48 18.9531C39.6935 17.7396 41.7738 17.7396 42.9874 18.9531L45.5011 21.467C46.7147 22.6805 46.7147 24.7609 45.5011 25.9745L26.4313 44.9582C25.2178 46.1718 23.1374 46.1718 21.9239 44.9582L19.4102 42.4444C18.1966 41.2308 18.1966 39.1504 19.4102 37.9368L38.48 18.9531Z"
          fill="white"
        />
        <path
          d="M19.4531 25.9302C18.2396 24.7167 18.2396 22.6363 19.4531 21.4228L21.967 18.909C23.1805 17.6955 25.2609 17.6955 26.4745 18.909L45.4582 37.9788C46.6718 39.1924 46.6718 41.2727 45.4582 42.4863L42.9444 45C41.7308 46.2135 39.6504 46.2135 38.4368 45L19.4531 25.9302Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5793_11990">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
};

export default ErrorIcon;
